import { render, staticRenderFns } from "./InitLayout.vue?vue&type=template&id=35303678&scoped=true&"
import script from "./InitLayout.vue?vue&type=script&lang=js&"
export * from "./InitLayout.vue?vue&type=script&lang=js&"
import style0 from "./InitLayout.vue?vue&type=style&index=0&id=35303678&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35303678",
  null
  
)

export default component.exports